var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouritesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6602 0.990044C15.0202 -0.809956 11.7602 0.0300438 10.0002 2.09004C8.24021 0.0300438 4.98021 -0.819956 2.34021 0.990044C0.940213 1.95004 0.0602132 3.57004 0.000213224 5.28004C-0.139787 9.16004 3.30021 12.27 8.55021 17.04L8.65021 17.13C9.41021 17.82 10.5802 17.82 11.3402 17.12L11.4502 17.02C16.7002 12.26 20.1302 9.15004 20.0002 5.27004C19.9402 3.57004 19.0602 1.95004 17.6602 0.990044ZM10.1002 15.55L10.0002 15.65L9.90021 15.55C5.14021 11.24 2.00021 8.39004 2.00021 5.50004C2.00021 3.50004 3.50021 2.00004 5.50021 2.00004C7.04021 2.00004 8.54021 2.99004 9.07021 4.36004H10.9402C11.4602 2.99004 12.9602 2.00004 14.5002 2.00004C16.5002 2.00004 18.0002 3.50004 18.0002 5.50004C18.0002 8.39004 14.8602 11.24 10.1002 15.55Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesIcon);
export default __webpack_public_path__ + "static/media/favouritesIcon.3cbb59c23dc2ca093919b283d288711e.svg";
export { ForwardRef as ReactComponent };